import { __decorate } from "tslib";
import psHttp from '@patsnap/common-ps-http';
import { workspaceApiUrlPrefix } from '@cores/constants/envConfig';
import { injectable } from '@/inversify.config';
let AiTaggingTourApiImpl = class AiTaggingTourApiImpl {
    getSpaceList(params) {
        return psHttp({
            url: `${workspaceApiUrlPrefix}/space/list`,
            method: 'POST',
            data: {
                ...params,
            },
            transformCode: true,
        }).then(({ data }) => {
            return data.data || {};
        });
    }
};
AiTaggingTourApiImpl = __decorate([
    injectable()
], AiTaggingTourApiImpl);
export { AiTaggingTourApiImpl };
